import { useState } from 'react'
import { Button, Checkbox, CloseButton, Drawer, Portal, Text, VStack } from '@chakra-ui/react'

/** [Spec §15.1 D4] Not at work today → Revisit; on a hybrid turf with a geocoded home, optionally visit at home today. */
export function NotAtWorkSheet({ open, name, canVisitHome, onConfirm, onClose }: {
  open: boolean; name: string; canVisitHome: boolean; onConfirm: (visitHome: boolean) => void; onClose: () => void
}) {
  const [visitHome, setVisitHome] = useState(false)
  // Default OFF on every open: reset during render when `open` flips, so a reused instance never carries a tick over.
  const [wasOpen, setWasOpen] = useState(open)
  if (wasOpen !== open) { setWasOpen(open); setVisitHome(false) }
  return (
    <Drawer.Root open={open} placement="bottom" onOpenChange={(e) => { if (!e.open) onClose() }}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="xl" pb="env(safe-area-inset-bottom, 0px)" shadow="popover">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" minW="44px" minH="44px" /></Drawer.CloseTrigger>
            <Drawer.Header><Drawer.Title>Not at work today</Drawer.Title></Drawer.Header>
            <Drawer.Body>
              <VStack align="stretch" gap={4} pb={4}>
                <Text color="fg.muted">{`${name} will come back up as a revisit.`}</Text>
                {canVisitHome && (
                  <Checkbox.Root checked={visitHome} onCheckedChange={(e) => setVisitHome(!!e.checked)} minH="44px">
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>Visit at home today</Checkbox.Label>
                  </Checkbox.Root>
                )}
                <Button minH="52px" bg="accent" color="accent.fg" onClick={() => onConfirm(canVisitHome && visitHome)}>Done</Button>
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}
